import http from '@/js/http'

const ExclusiveApi = {
    getExportTaskList: (data) => {
        return http.post('/exclusive/{parentShopId}/async_task/list', data)
    },
    cancelExportTask: (data) => {
        return http.put(`/exclusive/{parentShopId}/async_task/put/${data.taskId}`, data)
    },
    downloadExportTask: (data) => {
        return http.post(`/exclusive/{parentShopId}/async_file/download_file`, data, {
            responseType: 'blob'
        })
    },
    createExportTask: (data) => {
        return http.post(`/exclusive/{parentShopId}/async_task/add`, data)
    }
}

export default ExclusiveApi